import React from 'react';

export const StatusMessages = {
    created: 'New',
    incompleteRequesterAndSpender: (
        <span>
            Composing:
            <ul>
                <li>Spender fields: Missing</li>
                <li>Requester fields: Missing</li>
            </ul>
        </span>
    ),
    incompleteSpender: (
        <span>
            Composing:
            <ul>
                <li>Spender fields: Missing</li>
                <li>Requester fields: Completed</li>
            </ul>
        </span>
    ),
    incompleteRequester: (
        <span>
            Composing:
            <ul>
                <li>Spender fields: Completed</li>
                <li>Requester fields: Missing</li>
            </ul>
        </span>
    ),
    saved: (
        <span>
            Composing:
            <ul>
                <li>Spender fields: Completed</li>
                <li>Requester fields: Completed</li>
            </ul>
        </span>
    ),
    deniedByRequester: 'Rejected by Requester - to review',
    deniedBySB: 'Rejected by Strategic Buyer - to review',
    deniedByOb: 'Rejected by Operational Buyer - to review',
    pendingRequesterAndSpenderCompletion: (
        <span>
            Pending for Requester completion:
            <ul>
                <li>Spender fields: Missing</li>
                <li>Requester fields: Missing</li>
            </ul>
        </span>
    ),
    pendingSpenderCompletion: (
        <span>
            Pending for Requester completion:
            <ul>
                <li>Spender fields: Missing</li>
                <li>Requester fields: Completed</li>
            </ul>
        </span>
    ),
    pendingRequesterCompletion: (
        <span>
            Pending for Requester completion:
            <ul>
                <li>Spender fields: Completed</li>
                <li>Requester fields: Missing</li>
            </ul>
        </span>
    ),
    pendingRequesterCompletionSaved: (
        <span>
            Pending for Requester completion:
            <ul>
                <li>Spender fields: Completed</li>
                <li>Requester fields: Completed</li>
            </ul>
        </span>
    ),
    pendingSBApproval: 'On Hold - Pending for Strategic buyer review',
    pendingOBApproval: 'On Hold - Pending for Operational buyer review',
    submitted: 'Submitted in SAP',
};
